import config from 'config'
import { ActionTree } from 'vuex'
import * as types from './mutation-types'
import getApiEndpointUrl from '@vue-storefront/core/helpers/getApiEndpointUrl'
import { request as customerRequest } from '@vue-storefront/core/lib/customerRequest'
import RootState from '@vue-storefront/core/types/RootState'
import AddressesState from '../../types/Address/AddressesState'
import { v4 as uuidv4 } from 'uuid';

const actions: ActionTree<AddressesState, RootState> = {
  async loadList ({ commit }) {
    await commit(types.USER_ADDRESS_SET_LIST_LOADER, false);
    return await customerRequest(getApiEndpointUrl(config.users.address, 'list'))
      .then(res => {
        commit(types.USER_ADDRESS_SET_LIST, res.result);
        commit(types.USER_ADDRESS_SET_LIST_LOADER, true);
        return res.result;
      })
  },

  async loadGuestList ({ commit }) {
    try {
      let guestAddresses = JSON.parse(localStorage.getItem('shop/user/guest-addresses'));
      if (guestAddresses && guestAddresses.length) {
        commit(types.GUEST_ADDRESS_SET_LIST, guestAddresses);
      }
      return guestAddresses
    } catch (err) {
      console.error(err)
    }
  },

  async loadAddress ({ commit }, payload) {
    return customerRequest(getApiEndpointUrl(config.users.address, 'load'), 'GET', payload)
  },

  async setSelectedAddress ({ commit }, address) {
    commit(types.USER_ADDRESS_SET, address)
    return address
  },

  async addQuoteAddress ({ commit }, address) {
    return customerRequest(getApiEndpointUrl(config.users.guest.quote.address, 'update'), 'POST', address)
      .then(res => {
        return res.result.data;
      })
  },

  async addGuestAddress ({ commit }, address) {
    return customerRequest(getApiEndpointUrl(config.users.guest.quote.address, 'update'), 'POST', address)
      .then(res => {
        commit(types.GUEST_ADDRESS_ADD, res.result.data)
        return res.result.data;
      })
  },

  async updateGuestAddress ({ commit }, address) {
    return customerRequest(getApiEndpointUrl(config.users.guest.quote.address, 'update'), 'POST', address)
      .then(res => {
        commit(types.GUEST_ADDRESS_UPDATE, res.result.data)
        return res.result.data;
      })
  },

  async deleteQuoteAddress ({ commit }, address) {
    return customerRequest(getApiEndpointUrl(config.users.guest.quote.address, 'delete'), 'DELETE', address)
      .then(res => {
        return res.result.data;
      })
  },

  async guestAddressMakeDefault ({ commit }, addressId){
    commit(types.GUEST_ADDRESS_SET_DEFAULT, addressId);
  },

  async deleteGuestAddress ({ commit, state, dispatch }, addressId) {
    return dispatch('deleteQuoteAddress')
      .then(res => {
        const updatedAddressesList = state.guest_addresses.filter(address => address.id !== addressId);
        commit(types.GUEST_ADDRESS_DELETE, updatedAddressesList);
        return updatedAddressesList;
      })
      .catch(err => {
        console.error('Error deleting guest address:', err);
        return state.guest_addresses;
      })
  },

  async create ({ commit }, payload) {
    return await customerRequest(getApiEndpointUrl(config.users.address, 'create'), 'POST', payload)
      .then(res => {
        commit(types.USER_ADDRESS_ADD, res.result)
        return res.result
      })
  },

  async update ({ commit }, payload) {
    return customerRequest(getApiEndpointUrl(config.users.address, 'update'), 'PATCH', payload)
      .then(res => {
        commit(types.USER_ADDRESS_UPDATE, res.result)
      })
  },

  async delete ({ commit }, payload) {
    return customerRequest(getApiEndpointUrl(config.users.address, 'delete'), 'DELETE', payload)
      .then(res => {
        commit(types.USER_ADDRESS_DELETE, payload)
      })
  },

  async makeDefault ({ commit }, payload) {
    return customerRequest(getApiEndpointUrl(config.users.address, 'make_default'), 'PATCH', payload)
      .then(res => {
        commit(types.USER_ADDRESS_SET_LIST, res.result)
        return res.result.find(address => address.id === payload.address_id)
      })
  },

  async clearStateAfterLogout ({ commit }) {
    commit(types.USER_ADDRESS_CLEAR_STATE_AFTER_LOGOUT)
  },

  async clearGuestState ({ commit }) {
    commit(types.GUEST_ADDRESS_CLEAR_STATE)
  }
}

export default actions
